import React from "react";
import CategoryTabs from "./category_tabs/CategoryTabs";

export default function EffectsPage() {
  return (
    <div>
      <CategoryTabs />
    </div>
  );
}
